<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="0"
      :label="translation(translationList.street_type, 'Tip stradă')"
      :items="streetTypes"
      item-title="name"
      name="street_type"
      item-value="id"
      v-model="selectedStreetType"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
      :loading="loading"
      :disabled="loading"
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useAddressStore } from '~/plugins/store/address';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type { StreetType } from '~/types/Address';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => StreetType | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-address-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const addressStore = useAddressStore();
    const translationStore = useTranslationStore();
    const selectedStreetType = ref(modelValue.value ? modelValue.value : null);
    const streetTypes = ref<StreetType[]>([]);
    const translationList = ref<TranslationList>({});
    let initialSetupDone = false;
    const error = ref([]);
    const loading = ref(false);

    onMounted(async () => {
      loading.value = true;
      streetTypes.value = await addressStore.getStreetTypeList();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      initialSetupDone = true;
      loading.value = false;

      // Listen for validate events
      window.addEventListener('validate-address', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
      window.addEventListener('validate-house', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === 'street_type') {
        if (!selectedStreetType.value) {
          error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
        } else {
          error.value = [];
          emit('validation-address-status', { field: 'street_type', isValid: true });
        }
      }
    };

    watch(selectedStreetType, (newStreetType) => {
      if (initialSetupDone) {
        emit('update:modelValue', newStreetType);
      }
    });

    watch(modelValue, (newValue) => {
      error.value = [];
      if (newValue) {
        selectedStreetType.value = newValue;
      }
      const isValid = !!newValue;
      emit('validation-address-status', { field: 'street_type', isValid });
    });

    return {
      selectedStreetType,
      translationList,
      translation,
      streetTypes,
      error,
      loading
    };
  },
});
</script>

<style scoped>
</style>